import { useCluGetUserByTokenQuery } from '@e-kyc/graphql';

import { tokenManager } from '../utils/token-manager';

export function useEKycUser() {
  const token = tokenManager.getToken();

  const { data, loading, error } = useCluGetUserByTokenQuery({
    variables: {
      getUserByTokenInput: {
        token: token || '',
      },
    },
    fetchPolicy: 'network-only',
    skip: !token,
  });

  const userId = data?.cluGetUserByToken.user.id || '';

  return {
    token,
    userId,
    user: data?.cluGetUserByToken.user,
    loading,
    error,
  };
}
